/**
 * LinkContentSheet
 *
 * Promise-based sheet wrapper for the Link Content flow.
 * Presents LinkContentContent via SheetService and resolves with the
 * selected UserMediaEntity (or null when dismissed / closed without picking).
 * Mirrors ScheduleContentSheet's wrapper pattern.
 */

import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import { LinkContentContent } from './components/LinkContentContent';

export interface LinkContentSheetConfig {
    title: string;
    excludeMediaId: string;
    screenKey?: string;
}

const show = (
    config: LinkContentSheetConfig,
): Promise<UserMediaEntity | null> => {
    return new Promise((resolve) => {
        let resolved = false;

        const handleResolve = (result: UserMediaEntity | null) => {
            if (!resolved) {
                resolved = true;
                resolve(result);
            }
        };

        const handleDismiss = () => {
            if (!resolved) {
                resolved = true;
                resolve(null);
            }
        };

        SheetService.show({
            content: (
                <LinkContentContent
                    title={config.title}
                    excludeMediaId={config.excludeMediaId}
                    onResolve={handleResolve}
                />
            ),
            onClose: handleDismiss,
            container: config.screenKey,
            screenKey: config.screenKey,
            closeOnClickOutside: true,
        });
    });
};

export const LinkContentSheet = {
    show,
};
